export default function* putContentSignedUrl(URL, body) {
  return yield fetch(URL, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/zip'
    },
    body
  });
}
